const _cf = new URLSearchParams(window.location.search).get('_cf');
let useCF = _cf === '1' || _cf === 'true';
if (_cf === null) {
    useCF =
        process.env.cdn === undefined ||
        process.env.cdn === '1' ||
        process.env.cdn === 1 ||
        process.env.cdn === 'true' ||
        process.env.cdn === true;
}

// Cloudflare isn't used by default anymore
module.exports = {
    apiServerUrl: useCF ? 'https://api-staging.amplement.io' : 'https://api.staging.amplement.com',
    publicHostname: 'https://www.staging.amplement.com',
    websocketHostname: useCF
        ? 'https://ws-staging.amplement.io'
        : 'https://ws.staging.amplement.com',
    debug: false,
    logLevel: 'info',
    logFilter: 'myc:*'
};
